import server from 'utils/request';

/**
 * 获取一级菜单
 */
export function getOneMenu() {
  return server({
    url: '/sys/menu/one',
    method: 'post'
  })
}

/**
 * 获取所有菜单
 */
export function getAllMenu() {
  return server({
    url: '/sys/menu/all',
    method: 'get'
  })
}

/**
 * 获取二级和三级菜单
 * @param functionId 一级菜单ID  必填
 */
export function getTwoMenu(functionId) {
  var data = {
    functionId
  };
  return server({
    url: '/sys/menu/two',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}



// WEBPACK FOOTER //
// ./src/api/menu/menu.js